import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ApiService } from '../../data/ApiService.generated';
import { LogTypeScriptErrorCommandRequest } from '../../data/CommandServiceDtos.generated';
import { HandledException } from '..';

@Injectable()
export class GlobalExceptionHandler extends ErrorHandler {

  constructor(private injector: Injector) {
    super();
  }

  handleError(error) {
    if (error && error.rejection && error.rejection instanceof HandledException) {
      // squash the exception.
    } else {
      var apiService: ApiService = this.injector.get(ApiService);
      var request: LogTypeScriptErrorCommandRequest = new LogTypeScriptErrorCommandRequest();
      request.Message = GlobalExceptionHandler.asText(error.message ? error.message : error);
      request.Type = 'TypeScript';
      request.Stack = GlobalExceptionHandler.asText(error.stack);
      request.Url = window.location.href;

      apiService.LogTypeScriptError(request, false);
      super.handleError(error);
    }
  }

  /**
   * The server binds Message and Stack as strings. An error carrying an array
   * or object in either - a rejected command response, for one - used to be
   * posted as-is, and the bind failure ("Unexpected character encountered while
   * parsing value: [") was reported instead of the error that actually happened.
   */
  private static asText(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    if (Array.isArray(value)) {
      return value.map(entry => GlobalExceptionHandler.asText(entry)).join(' | ');
    }
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }

}
